import React from 'react'
import NestedNav from './NestedNav'
import NestedDisplay from './NestedDisplay'

const NestedRoute = () => {
  return (
    <div className='nestedRoute'>
      <NestedNav/>
      <NestedDisplay/>
    </div>
  )
}

export default NestedRoute
